import { Component, Input } from '@angular/core';
import {STATO_ENUM_UI} from "../../../_helpers/StatoEnum";

@Component({
    selector: 'app-ordine-stato-label',
    templateUrl: './ordine-stato-label.component.html',
    styleUrls: ['./ordine-stato-label.component.scss'],
    standalone: false
})
export class OrdineStatoLabelComponent {
  @Input() ordineStato: number;
  protected readonly STATO_ENUM_UI = STATO_ENUM_UI;
}
